import script from "./reaction-shoutout-received-dm.vue?vue&type=script&setup=true&lang=js"
export * from "./reaction-shoutout-received-dm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__